import React from 'react'

export default function ShowEspecifications( {items} ) {
  return (
    <div>
        <p style={{fontSize:'20px'}}>Especificaciones</p>
        { items.map( (item,index) =>{
            return <p key={index}> {item.title} : {item.description}</p> ;
        }

        ) }
    </div>
  )
}
